import React from "react";

export default function Footer() {
  return (
    <footer className="flex text-center px-4 py-8 justify-center">
      <p className="text-sm">
        Copyright 2020 • All Rights Reserved Ethan Shop by https://ekosetiaji.my.id
      </p>
    </footer>
  );
}
